// extracted by mini-css-extract-plugin
module.exports = {"fade":"styles_fade__zli3T","visible":"styles_visible__suHiT"};